import app from '../../forum/app';
import NotificationList from './NotificationList';
import extractText from '../../common/utils/extractText';
import HeaderDropdown from './HeaderDropdown';
import classList from '../../common/utils/classList';
export default class NotificationsDropdown extends HeaderDropdown {
  static initAttrs(attrs) {
    attrs.className = classList('NotificationsDropdown', attrs.className);
    attrs.icon || (attrs.icon = 'fas fa-bell');

    // For best a11y support, both `title` and `aria-label` should be used
    attrs.accessibleToggleLabel || (attrs.accessibleToggleLabel = extractText(app.translator.trans('core.forum.notifications.toggle_dropdown_accessible_label')));
    super.initAttrs(attrs);
  }
  getContent() {
    return m(NotificationList, {
      state: this.attrs.state
    });
  }
  goToRoute() {
    m.route.set(app.route('notifications'));
  }
  getUnreadCount() {
    return app.session.user.unreadNotificationCount();
  }
  getNewCount() {
    return app.session.user.newNotificationCount();
  }
}
flarum.reg.add('core', 'forum/components/NotificationsDropdown', NotificationsDropdown);